import { baseApi } from './baseApi';
import { CompanyProfile } from 'models/CompanyProfile';
import { QueryParams, TAG_TYPES } from 'types';
import { getQueryParams } from 'utils';

const URL_COMPANY_PROFILE = 'company-profiles';

const companyProfileApiService = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getCompanyProfiles: builder.query<
      {
        data: {
          rows: CompanyProfile[];
          count: number;
        };
        success: boolean;
      },
      { query?: QueryParams }
    >({
      query: (params) => {
        const query = getQueryParams(params?.query || {});
        if (query === '') return { url: URL_COMPANY_PROFILE, method: 'GET' };
        return {
          url: `${URL_COMPANY_PROFILE}?${query}`,
          method: 'GET',
        };
      },
      providesTags: (result) =>
        result
          ? [
              ...(result?.data.rows || []).map(({ id }) => ({ type: TAG_TYPES.CompanyProfile, id })),
              { type: TAG_TYPES.CompanyProfile, id: 'LIST' },
            ]
          : [{ type: TAG_TYPES.CompanyProfile, id: 'LIST' }],
    }),

    updateCompanyProfile: builder.mutation<CompanyProfile, Partial<CompanyProfile> & { id: string }>({
      query: ({ id, ...patch }) => ({
        url: `${URL_COMPANY_PROFILE}/${id}`,
        method: 'PUT',
        data: patch,
      }),
      invalidatesTags: (result, error, { id }) => [
        { type: TAG_TYPES.CompanyProfile, id },
        { type: TAG_TYPES.CompanyProfile, id: 'LIST' },
      ],
    }),
  }),
  overrideExisting: false,
});

export const { useGetCompanyProfilesQuery, useLazyGetCompanyProfilesQuery, useUpdateCompanyProfileMutation } =
  companyProfileApiService;
